"use client";
// import type { Metadata } from "next";
import { motion } from "framer-motion";
import Hero from "./hero";
import Companies from "./companies";
import Features from "./features";
import Portfolio from "./portfolio";
import FAQ from "./faq";
import Reviews from "./reviews";
import CTA from "./cta";
import { pageTransition } from "../../lib/animations";
import ProofOfWork from "./proof";

export default function HomeSection() {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageTransition}
    >
      <Hero />
      <Companies />
      <Features />
      <Portfolio />
      <Reviews />
      <ProofOfWork />
      <FAQ />
      <CTA />
    </motion.div>

  );
}
